import { Injectable, NgModule, Component, forwardRef, NgZone, Inject, Input, EventEmitter, Output, defineInjectable } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import 'tinymce/tinymce.min';
import 'tinymce/themes/modern/theme';
import 'tinymce/plugins/link/plugin.js';
import 'tinymce/plugins/paste/plugin.js';
import 'tinymce/plugins/table/plugin.js';
import 'tinymce/plugins/advlist/plugin.js';
import 'tinymce/plugins/autoresize/plugin.js';
import 'tinymce/plugins/lists/plugin.js';
import 'tinymce/plugins/code/plugin.js';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class Angular2TinymceLibService {
    constructor() {
    }
}
Angular2TinymceLibService.ɵfac = function Angular2TinymceLibService_Factory(t) { return new (t || Angular2TinymceLibService)(); };
Angular2TinymceLibService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: Angular2TinymceLibService, factory: Angular2TinymceLibService.ɵfac, providedIn: 'root' });
/** @nocollapse */
Angular2TinymceLibService.ctorParameters = () => [];
/** @nocollapse */ Angular2TinymceLibService.ngInjectableDef = defineInjectable({ factory: function Angular2TinymceLibService_Factory() { return new Angular2TinymceLibService(); }, token: Angular2TinymceLibService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(Angular2TinymceLibService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class TinymceDefaultOptions {
    constructor() {
        this.plugins = [
            'link',
            'paste',
            'table',
            'advlist',
            'autoresize',
            'lists',
            'code'
        ];
        this.skin_url = '/assets/tinymce/skins/lightgray';
        this.baseURL = '/assets/tinymce';
        this.auto_focus = true;
    }
}
TinymceDefaultOptions.ɵfac = function TinymceDefaultOptions_Factory(t) { return new (t || TinymceDefaultOptions)(); };
TinymceDefaultOptions.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: TinymceDefaultOptions, factory: TinymceDefaultOptions.ɵfac });


/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
const noop = () => {
};
class TinymceComponent {
    /**
     * @param {?} zone
     * @param {?} globalOptions
     */
    constructor(zone, globalOptions) {
        this.zone = zone;
        this.globalOptions = globalOptions;
        this.click = new EventEmitter();
        this.dblclick = new EventEmitter();
        this.mousedown = new EventEmitter();
        this.mouseup = new EventEmitter();
        this.mousemove = new EventEmitter();
        this.mouseover = new EventEmitter();
        this.mouseout = new EventEmitter();
        this.mouseenter = new EventEmitter();
        this.mouseleave = new EventEmitter();
        this.keydown = new EventEmitter();
        this.keypress = new EventEmitter();
        this.keyup = new EventEmitter();
        this.contextmenu = new EventEmitter();
        this.paste = new EventEmitter();
        this.init = new EventEmitter();
        this.focus = new EventEmitter();
        this.blur = new EventEmitter();
        this.beforeSetContent = new EventEmitter();
        this.setContent = new EventEmitter();
        this.getContent = new EventEmitter();
        this.preProcess = new EventEmitter();
        this.postProcess = new EventEmitter();
        this.nodeChange = new EventEmitter();
        this.undo = new EventEmitter();
        this.redo = new EventEmitter();
        this.change = new EventEmitter();
        this.dirty = new EventEmitter();
        this.remove = new EventEmitter();
        this.execCommand = new EventEmitter();
        this.pastePreProcess = new EventEmitter();
        this.pastePostProcess = new EventEmitter();
        this.elementId = 'tiny-' + Math.random().toString(36).substring(2);
        this.onTouchedCallback = noop;
        this.onChangeCallback = noop;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.options = Object.assign(new TinymceDefaultOptions(), this.globalOptions, this.optionsOverride);
        this.options.selector = '#' + this.elementId;
        this.options.setup = editor => {
            this.setupEvents(editor);
        };
        this.options.init_instance_callback = editor => {
            if (editor && this.value) {
                editor.setContent(this.value);
            }
            this.editor = editor;
        };
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.options.baseURL) {
            tinymce.baseURL = this.options.baseURL;
        }
        tinymce.init(this.options);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        tinymce.remove(this.editor);
    }
    /**
     * @return {?}
     */
    get value() {
        return this.innerValue;
    }
    /**
     * @param {?} v
     * @return {?}
     */
    set value(v) {
        if (v !== this.innerValue) {
            this.innerValue = v;
            this.zone.run(() => {
                this.onChangeCallback(v);
            });
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    writeValue(value) {
        if (value !== this.innerValue) {
            this.innerValue = value;
            if (!value) {
                value = '';
            }
            if (this.editor && this.editor.initialized) {
                this.editor.setContent(value);
            }
        }
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    /**
     * @param {?} editor
     * @return {?}
     */
    setupEvents(editor) {
        editor.on('change keyup', () => {
            /** @type {?} */
            const content = editor.getContent();
            this.value = content;
        });
        editor.on('click', e => {
            this.click.emit(e);
        });
        editor.on('dblclick', e => {
            this.dblclick.emit(e);
        });
        editor.on('mousedown', e => {
            this.mousedown.emit(e);
        });
        editor.on('mouseup', e => {
            this.mouseup.emit(e);
        });
        editor.on('mousemove', e => {
            this.mousemove.emit(e);
        });
        editor.on('mouseover', e => {
            this.mouseover.emit(e);
        });
        editor.on('mouseout', e => {
            this.mouseout.emit(e);
        });
        editor.on('mouseenter', e => {
            this.mouseenter.emit(e);
        });
        editor.on('mouseleave', e => {
            this.mouseleave.emit(e);
        });
        editor.on('keydown', e => {
            this.keydown.emit(e);
        });
        editor.on('keypress', e => {
            this.keypress.emit(e);
        });
        editor.on('keyup', e => {
            this.keyup.emit(e);
        });
        editor.on('contextmenu', e => {
            this.contextmenu.emit(e);
        });
        editor.on('paste', e => {
            this.paste.emit(e);
        });
        editor.on('init', e => {
            this.init.emit(e);
        });
        editor.on('focus', e => {
            this.focus.emit(e);
        });
        editor.on('blur', e => {
            this.blur.emit(e);
        });
        editor.on('BeforeSetContent', e => {
            this.beforeSetContent.emit(e);
        });
        editor.on('SetContent', e => {
            this.setContent.emit(e);
        });
        editor.on('GetContent', e => {
            this.getContent.emit(e);
        });
        editor.on('PreProcess', e => {
            this.preProcess.emit(e);
        });
        editor.on('PostProcess', e => {
            this.postProcess.emit(e);
        });
        editor.on('NodeChange', e => {
            this.nodeChange.emit(e);
        });
        editor.on('Undo', e => {
            this.undo.emit(e);
        });
        editor.on('Redo', e => {
            this.redo.emit(e);
        });
        editor.on('Change', e => {
            this.change.emit(e);
        });
        editor.on('Dirty', e => {
            this.dirty.emit(e);
        });
        editor.on('Remove', e => {
            this.remove.emit(e);
        });
        editor.on('ExecCommand', e => {
            this.execCommand.emit(e);
        });
        editor.on('PastePreProcess', e => {
            this.pastePreProcess.emit(e);
        });
        editor.on('PastePostProcess', e => {
            this.pastePostProcess.emit(e);
        });
    }
}
TinymceComponent.ɵfac = function TinymceComponent_Factory(t) { return new (t || TinymceComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject('TINYMCE_CONFIG')); };
TinymceComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TinymceComponent, selectors: [["app-tinymce"]], inputs: { optionsOverride: ["options", "optionsOverride"] }, outputs: { click: "click", dblclick: "dblclick", mousedown: "mousedown", mouseup: "mouseup", mousemove: "mousemove", mouseover: "mouseover", mouseout: "mouseout", mouseenter: "mouseenter", mouseleave: "mouseleave", keydown: "keydown", keypress: "keypress", keyup: "keyup", contextmenu: "contextmenu", paste: "paste", init: "init", focus: "focus", blur: "blur", beforeSetContent: "beforeSetContent", setContent: "setContent", getContent: "getContent", preProcess: "preProcess", postProcess: "postProcess", nodeChange: "nodeChange", undo: "undo", redo: "redo", change: "change", dirty: "dirty", remove: "remove", execCommand: "execCommand", pastePreProcess: "pastePreProcess", pastePostProcess: "pastePostProcess" }, exportAs: ["tinymce"], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => TinymceComponent),
                multi: true
            }
        ])], decls: 1, vars: 1, consts: [[3, "id"]], template: function TinymceComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵpropertyInterpolate("id", ctx.elementId);
    } }, encapsulation: 2 });
/** @nocollapse */
TinymceComponent.ctorParameters = () => [
    { type: NgZone },
    { type: undefined, decorators: [{ type: Inject, args: ['TINYMCE_CONFIG',] }] }
];
TinymceComponent.propDecorators = {
    optionsOverride: [{ type: Input, args: ['options',] }],
    click: [{ type: Output }],
    dblclick: [{ type: Output }],
    mousedown: [{ type: Output }],
    mouseup: [{ type: Output }],
    mousemove: [{ type: Output }],
    mouseover: [{ type: Output }],
    mouseout: [{ type: Output }],
    mouseenter: [{ type: Output }],
    mouseleave: [{ type: Output }],
    keydown: [{ type: Output }],
    keypress: [{ type: Output }],
    keyup: [{ type: Output }],
    contextmenu: [{ type: Output }],
    paste: [{ type: Output }],
    init: [{ type: Output }],
    focus: [{ type: Output }],
    blur: [{ type: Output }],
    beforeSetContent: [{ type: Output }],
    setContent: [{ type: Output }],
    getContent: [{ type: Output }],
    preProcess: [{ type: Output }],
    postProcess: [{ type: Output }],
    nodeChange: [{ type: Output }],
    undo: [{ type: Output }],
    redo: [{ type: Output }],
    change: [{ type: Output }],
    dirty: [{ type: Output }],
    remove: [{ type: Output }],
    execCommand: [{ type: Output }],
    pastePreProcess: [{ type: Output }],
    pastePostProcess: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TinymceComponent, [{
        type: Component,
        args: [{
                selector: 'app-tinymce',
                template: '<div id="{{elementId}}"></div>',
                exportAs: 'tinymce',
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => TinymceComponent),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.NgZone }, { type: undefined, decorators: [{
                type: Inject,
                args: ['TINYMCE_CONFIG']
            }] }]; }, { click: [{
            type: Output
        }], dblclick: [{
            type: Output
        }], mousedown: [{
            type: Output
        }], mouseup: [{
            type: Output
        }], mousemove: [{
            type: Output
        }], mouseover: [{
            type: Output
        }], mouseout: [{
            type: Output
        }], mouseenter: [{
            type: Output
        }], mouseleave: [{
            type: Output
        }], keydown: [{
            type: Output
        }], keypress: [{
            type: Output
        }], keyup: [{
            type: Output
        }], contextmenu: [{
            type: Output
        }], paste: [{
            type: Output
        }], init: [{
            type: Output
        }], focus: [{
            type: Output
        }], blur: [{
            type: Output
        }], beforeSetContent: [{
            type: Output
        }], setContent: [{
            type: Output
        }], getContent: [{
            type: Output
        }], preProcess: [{
            type: Output
        }], postProcess: [{
            type: Output
        }], nodeChange: [{
            type: Output
        }], undo: [{
            type: Output
        }], redo: [{
            type: Output
        }], change: [{
            type: Output
        }], dirty: [{
            type: Output
        }], remove: [{
            type: Output
        }], execCommand: [{
            type: Output
        }], pastePreProcess: [{
            type: Output
        }], pastePostProcess: [{
            type: Output
        }], optionsOverride: [{
            type: Input,
            args: ['options']
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class TinymceModule {
    /**
     * @param {?=} userConfig
     * @return {?}
     */
    static withConfig(userConfig = {}) {
        return {
            ngModule: TinymceModule,
            providers: [
                { provide: 'TINYMCE_CONFIG', useValue: userConfig }
            ]
        };
    }
}
TinymceModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TinymceModule });
TinymceModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TinymceModule_Factory(t) { return new (t || TinymceModule)(); }, providers: [
        { provide: 'TINYMCE_CONFIG', useClass: TinymceDefaultOptions }
    ], imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TinymceModule, { declarations: [TinymceComponent], exports: [TinymceComponent] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TinymceModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [TinymceComponent],
                exports: [TinymceComponent],
                providers: [
                    { provide: 'TINYMCE_CONFIG', useClass: TinymceDefaultOptions }
                ]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { Angular2TinymceLibService, TinymceComponent, TinymceModule, TinymceDefaultOptions as ɵb };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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